import { RefObject } from "react";
import { ViewTableHandle } from "@design-system/ViewTable/ViewTable";
import { useCounterpartyRefContextMaybe } from "./CounterpartyRefContext";
import { useRefRowHighlight } from "./useRefRowHighlight";

export function useCounterpartyRowHighlight<TRowId extends string | number>({
    resolveTableRowId,
    tableRef,
}: {
    resolveTableRowId: (counterpartyId: string) => TRowId | undefined;
    tableRef?: RefObject<ViewTableHandle | null>;
}) {
    const counterpartyRefCtx = useCounterpartyRefContextMaybe();
    return useRefRowHighlight({
        focusedId: counterpartyRefCtx?.focusedCounterpartyId ?? null,
        resolveTableRowId,
        tableRef,
    });
}
